import React, { useState, useRef, useEffect } from 'react';
import { BsCardImage } from 'react-icons/bs';
import './UploadInterface.scss';
import Popup from './Popup';

const UploadInterface = () => {
  const fileInputRef = useRef();
  const [showPopup, setShowPopup] = useState(false);

  const handleFileClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    console.log(file);
  };

  const handleNavigate = () => {
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
  };

  // Close popup when clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showPopup && !event.target.closest('.popup')) {
        closePopup();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [showPopup]);

  return (
    <div className="upload-interface">
       <div className="upload-instructions">
       Please upload a photo of your ID card (front and back), including the complete card number frame, name, photo, etc. (cannot be altered or blurred*)
      </div>
      <div className="image-upload-area" onClick={handleFileClick}>
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          style={{ display: 'none' }}
          accept=".jpg,.jpeg,.png,.bmp"
        />
        <BsCardImage className="upload-icon" />
        <div className="upload-text">Submit ID photo (required)</div>
        <div className="upload-note">(Supports JPG/JPEG/PNG/BMP format, less than 10MB)</div>
      </div>
      {/* Existing elements */}
      {/* Other elements */}
      <button className="navigate-button" onClick={handleNavigate}>Confirm submission of documents</button>
      {showPopup && <Popup isOpen={showPopup} onClose={closePopup} />}
    </div>
  );
};

export default UploadInterface;
